import { Navigate, Outlet } from 'react-router';
import { useFeatureFlags } from '@/hooks/use-feature-flags';

export function RequireAudiencesFeatureLayout() {
  const { data, isPending } = useFeatureFlags();

  if (isPending) {
    return <div></div>;
  }

  if (!data?.audiencesEnabled) {
    return <Navigate to=".." replace />;
  }

  return <Outlet />;
}
